import React from 'react'

const Spoiler = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M118.45 366.297c-14.546 0-26.381-11.834-26.381-26.381v-21.028c0-5.461 4.427-9.888 9.888-9.888l47.41-.058v31.763c0 14.112-11.481 25.593-25.593 25.593h-5.324zM388.832 366.084c-14.547 0-26.381-11.834-26.381-26.381v-30.741l47.411-.176c5.461 0 9.888 4.428 9.888 9.888v21.816c0 14.112-11.481 25.593-25.593 25.593h-5.325z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M478.334 341.669c-5.042 0-10.495-1.561-16.209-4.639-.069-.038-49.318-28.102-49.318-28.102H99.572s-49.249 28.064-49.318 28.102c-5.712 3.078-11.166 4.638-16.208 4.639-7.3.001-13.556-3.279-17.613-9.236-3.535-5.189-5.328-12.375-5.328-21.358v-69.831c0-17.8 8.867-34.19 23.718-43.843.195-.127.394-.246.598-.359l59.485-32.946a9.889 9.889 0 0 1 4.791-1.238h312.984c1.676 0 3.325.426 4.791 1.238l59.484 32.946c.204.113.403.233.598.359 14.852 9.652 23.719 26.042 23.719 43.843v69.831c0 28.387-17.557 30.594-22.939 30.594z"
    />
    <path fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} d="M53.686 236.402l50.747-27.267h299.935l47.717 28.782" />
  </svg>
)
export default Spoiler
